export default __webpack_public_path__ + "static/media/gel-tropicana-1.51724a1d.jpg";